import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue"
import { MissionLifecycleFragmentFragment, MissionContractPayment } from "@/gql"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"
import { PaymentFormValues } from "@/modules/Missions/components/Payment/CreatePaymentStructureForm.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'AttachClientPayment',
  props: {
    mission: null,
    activePaymentIndex: null,
    activePayment: null,
    form: null
  },
  emits: ["close", "back", "complete", "updateClientPayment"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
  (e: "back"): void
  (e: "complete"): void
  (e: "updateClientPayment", paymentIndex: number, prn: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
  activePaymentIndex: number
  activePayment?: string | null
  form: PaymentFormValues[]
}



const attachClientPaymentForm = ref<{
  [key in string]: string | null
}>({
  [props.activePaymentIndex]: null,
})



const allPayments = computed(() => {
  if (!props.mission.missionContract?.missionContractPayments) return []
  return props.mission.missionContract.missionContractPayments
})

const activePaymentId = computed(() => {
  return props.form[props.activePaymentIndex]?.clientPayment
})

const liveUnusedPayments = computed(() => {
  const usedPaymentPrns = props.form
    .map((formItem) => formItem.clientPayment)
    .filter(Boolean) as string[]

  const unusedPayments = allPayments.value.filter((payment) => {
    return !usedPaymentPrns.includes(payment.prn)
  })

  return unusedPayments
})

const attachedPayments = computed(() => {
  const attPayments = props.form.reduce((acc, formItem, index) => {
    const payment = allPayments.value.find((p) => p.prn === formItem.clientPayment)
    if (payment) {
      acc[index] = payment as MissionContractPayment
    }
    return acc
  }, {} as Record<number, MissionContractPayment>)

  return attPayments
})

const renderedPayments = computed(() => {
  if (!attachedPayments.value?.[props.activePaymentIndex]) {
    return liveUnusedPayments.value
  }

  const payload = new Set([
    attachedPayments.value[props.activePaymentIndex] as MissionContractPayment,
    ...(liveUnusedPayments.value as MissionContractPayment[]),
  ])

  return [...payload].sort((a, b) => a?.id - b?.id)
})

onMounted(() => {
  attachClientPaymentForm.value[props.activePaymentIndex] = activePaymentId.value ?? null
})

return { __sfc: true,props, attachClientPaymentForm, emit, allPayments, activePaymentId, liveUnusedPayments, attachedPayments, renderedPayments, MoneyDisplay, Header }
}

})